
export class Cart {
    constructor(cartJSON) {
        this.cart = cartJSON;

        this.endpoints = {
            add: {
                url: 'cart/add.js',
                method: 'post'
            },
            get: {
                url: 'cart.js',
                method: 'get'
            },
            update: {
                url: 'cart/update.js',
                method: 'post'
            },
            change: {
                url: 'cart/change.js',
                method: 'post'
            },
            clear: {
                url: 'cart/clear.js',
                method: 'post'
            }
        };

        this.init();
    }


    init() {
        console.log('🚀🚀🚀 Cart initialised... ', this.cart );

        window.addEventListener('cart_updated', this.cartUpdateEvents.bind(this) );
    }

    dispatchEvent(event_name, includeCart) {
        console.log("🌈 event_name", event_name);

        let contents = null;
        if (includeCart) {
            contents = {
                detail: {
                cart: this.cart,
                },
            };
        }
        window.dispatchEvent(new CustomEvent(event_name, contents));
    }


    // Events Fired on Cart Update
    async cartUpdateEvents() {
        // this.updateCartCounter();
        window.refreshCart();
    }


    // GET Cart Details
    async get() {
        const endpoint = window.Shopify.routes.root + this.endpoints.get.url
        console.log('GET Cart Endpoint: ', endpoint );

        try {
            const response = await fetch( endpoint , {
            method: this.endpoints.get.method,
            headers: {
                'Content-Type': 'application/json',
                // Include other headers if necessary
            },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            this.cart = data;
            // console.log('CART: ', this.cart);
            this.dispatchEvent('cart_get', true);
            return this.cart;

        } catch (error) {
            this.dispatchEvent('cart_error', true)
            throw error;
        }
    }

    // Add Product to Cart
    add(data) {
        const endpoint = window.Shopify.routes.root + this.endpoints.add.url;

        fetch( endpoint, {
            method: this.endpoints.add.method,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then( response => {
            // console.log('🚀🚀🚀 response: ', response);

            if (!response.ok) {
                // If the response is not OK, attempt to parse the error details from the response
                return response.json().then(errorData => {
                    // console.log('Error Title: ', errorData.message || 'No title provided');
                    // console.log('Error Description: ', errorData.description || 'No description provided');
                    // Optionally, throw an error to handle it in the catch block

                    /*
                    const options = {
                        title: errorData.message,
                        message: errorData.description,
                        delay: 3000,
                        background: "#d1001f",
                        image: "https://cdn.shopify.com/s/files/1/0271/3973/5629/files/fila-square-logo.png?v=1716972363&width=100"
                    };
                    window.toasty.addToast(options);
                    */

                    throw new Error(errorData.message || 'Error adding to cart');


                });
            }

            // If the response is OK, parse the JSON
            return response.json();
        })
        .then(data => {
            // Handle successful response data
            console.log('Success:', data);

            this.mergeWithCurrentCart(data);
            this.dispatchEvent('cart_changed', true);
            this.dispatchEvent('item_added', true);

            const items_added = data.items;

            if ( items_added.length > 0 ) {

                items_added.forEach( item => {

                    /*
                    const options = {
                        title: "Item Added to Cart",
                        message: `${ item.title } has been added to Cart`,
                        delay: 2000,
                        // background: "var(--secondary-color)",
                        image: "https://cdn.shopify.com/s/files/1/0271/3973/5629/files/fila-square-logo.png?v=1716972363&width=100"
                    };
                    window.toasty.addToast(options);
                    */

                });
            }


            // Open Cart
            const cart_toggle = document.querySelector('.header__icon--cart.cart-drawer-toggle');
            if ( cart_toggle ) cart_toggle.click();


        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }


    mergeWithCurrentCart(data) {
        if (data.items) {

            data.items.forEach((item) => {
                let index = this.cart.items.findIndex(e => e.id === item.id);
                if (index > -1) {
                    this.cart.items[index] = item;
                    // console.log( 'Updated existing item!', this.cart, ' | item: ', item );

                } else {
                    this.cart.items.push(item);
                    // console.log( 'Added new item!', this.cart, ' | item: ', item );

                }
            });

            let item_count = 0;
            this.cart.items.forEach( item => {
                item_count += item.quantity;
            })
            this.cart.item_count = item_count;

            // console.log('🚀🚀🚀🚀 Merged Cart...', data.items, ' New Count: ', item_count );
            this.dispatchEvent( 'cart_updated', true );
        }
    }



    /*
    // Update Cart Item Counters
    updateCartCounter() {
        const cartCounters = document.querySelectorAll('[data-cart-count-bubble]');
        const item_count = this.cart.item_count;

        if ( cartCounters.length > 0 ) {

            cartCounters.forEach( cartCounter => {
                const counterText = cartCounter.querySelector('[data-cart-count]');

                if ( !item_count || item_count === 0  ) {
                    counterText.innerHTML = '';
                    cartCounter.classList.add('hide');

                } else {
                    counterText.innerHTML = item_count;
                    cartCounter.classList.remove('hide');
                }

            });

            console.log('🚀 Cart Counter Updated!.. ', item_count);

        }
    }
    */

}
// window.Cart = Cart;
